import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class DataAdminService {

    public urlWebApi: string = "https://sai.transtv.co.id/web-api/";

    constructor(private http: HttpClient) { }

    /** CEK LOGIN */
    login(data) {
        return this.http.post(this.urlWebApi + "index.php/cek-login", { nik: data['nik'], token: data['token'], perusahaan: 'TRANSTV' })
            .pipe(map((res) => { return res }))
    }

    /** DELETE ADMIN */
    deleteData(data) {
        return this.http.post(this.urlWebApi + "index.php/delete-data-admin", { nik: data['nik'], token: data['token'], perusahaan: 'TRANSTV', id: data['id'] })
            .pipe(map((res) => { return res }))
    }

    /** NEW ADMIN */
    newData(data) {
        return this.http.post(this.urlWebApi + "index.php/new-data-admin", { nik: data['nik'], token: data['token'], perusahaan: 'TRANSTV', role: data['role'], nik_admin: data['nik_admin'] })
            .pipe(map((res) => { return res }))
    }

}